'use strict';

const MobileDetect = require('mobile-detect');

const getDevice = () => {
    const md = new MobileDetect(window.navigator.userAgent);
    let device = 'DESKTOP';

    if (md.phone()) {
        device = 'MOBILE';
    } else if (md.tablet()) {
        device = 'TABLET';
    }

    return device;
};

module.exports = getDevice;
